export const updateBarcode = /* GraphQL */ `
  mutation UpdateBarcode(
    $input: UpdateBarcodeInput!
    $condition: ModelBarcodeConditionInput
  ) {
    updateBarcode(input: $input, condition: $condition) {
      id
      owner
      active
      status
      value
      isScanned
      scannedOut
      reloadYardId
      inventoryId
      locationId
      inventoryItemId
    }
  }
`;

export const updateBarcodeLocation = /* GraphQL */ `
  mutation UpdateBarcode(
    $input: UpdateBarcodeInput!
    $condition: ModelBarcodeConditionInput
  ) {
    updateBarcode(input: $input, condition: $condition) {
      id
    }
  }
`;
